//check for height changes on a skybox

export default function (options) {
    let target = options.target;

    var addHeightChangeEvent = function (element) {
        var oldHeight = target.style.height,
            observer = new MutationObserver(function (mutations) {
                mutations.forEach(function (mutation) {
                    if (
                        mutation.target === element &&
                        mutation.attributeName === 'style' &&
                        oldHeight !== element.style.height
                    ) {
                        oldHeight = target.style.height;
                        element.dispatchEvent(new Event('heightChange'));
                    }
                });
            });

        var config = {
            attributes: true,
        };
        observer.observe(element, config);
    };

    if (target) {
        addHeightChangeEvent(target);
        target.addEventListener(
            'heightChange',
            function (event) {
                if (!target.style.height) {
                    console.log('skybox closed');
                    $('body').addClass('skybox-closed');
                } else {
                    $('body').removeClass('skybox-closed');
                }
            },
            false,
        );
    }
}
